export default __webpack_public_path__ + "static/stage-1_1-c52f4c2e2ff2525ee40d6b6b002f5553.jpg";